$(function ()
{
	if (typeof FroalaEditor == "undefined") {
		return;
	}

	// The expression may itself contain markup with quotes (e.g. an <a href="..."> link),
	// which would otherwise end the data-param1 attribute early.
	function escapeAttribute(value)
	{
		return String(value)
			.replace(/&/g, '&amp;')
			.replace(/"/g, '&quot;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;');
	}

	FroalaEditor.RegisterCommand('keywords', {
		icon: 'book-spells',
		title: 'Keywords',
		type: 'dropdown',
		focus: false,
		undo: true,
		refreshAfterCallback: false,

		html: function ()
		{
			var options = this.opts.keywords;

			let html = '<ul class="fr-dropdown-list" role="presentation">';
			for (var val in options) {
				if (options.hasOwnProperty(val)) {
					if (typeof (options[val]) == "string") {
						html = html.concat('<li role="presentation" class="group">' + options[val] + '</li>');
					} else {
						html = html.concat('<li role="presentation"><a class="fr-command fr-title ct-extended" tabIndex="-1" role="option" data-cmd="keywords" data-param1="' + escapeAttribute(options[val].expression) + '">');
						html = html.concat('<div class="title">' + options[val].title + '</div>');
						html = html.concat('<div class="description">' + options[val].description + '</div>');
						html = html.concat('</a>');
						html = html.concat('</li>');
					}
				}
			}

			html = html.concat('</ul>');
			return html;
		},

		callback: function (cmd, val)
		{
			this.html.insert(val);
			this.undo.saveStep();
		},
		// Callback on refresh.
		refresh: function ($btn)
		{
		},
		// Callback on dropdown show.
		refreshOnShow: function ($btn, $dropdown)
		{
		}
	});

});
